import * as angular from "angular";
import { FolderInfo, FileRestService } from 'isogd-file-rest';

class FolderController {
  folderInfo: FolderInfo;
  onOpen: (args: any) => void;
  myBlockUI: any;
  editor: boolean;

  static $inject = ['$state', 'fileRestService', 'blockUI', 'toastr'];
  constructor(private $state: any, private fileRestService: FileRestService, private blockUI: any, private toastr: Toastr) {
  }

  $onInit() {
    this.myBlockUI = this.blockUI.instances.get('folderLoad');
  }

  open(id: string) {
    this.onOpen({ folderInfo: this.folderInfo });
  }

  $onDestroy() {
    this.myBlockUI.reset();
  }

  changeVisibl() {
    let hide: string = "";
    let message: string = "";
    if ((<any>this.folderInfo).hidden) {
      hide = "hide";
      message = "Каталог скрыт на портале";
    } else {
      hide = "show";
      message = "Каталог отображается на портале";
    }

    this.fileRestService.hideFolder(this.folderInfo.folderId, hide).then(response => {
      this.toastr.success(message);
      this.$state.reload();
    }).catch(error => {
      this.toastr.success("Ошибка при изменении видимости каталога");
    });
  }
}

export const folder: angular.IComponentOptions = {
  controller: FolderController,
  template: require('./folder.html'),
  bindings: {
    folderInfo: '<',
    onOpen: '&',
    editor: '<'
  }
};



// WEBPACK FOOTER //
// ./src/components/files/folder-tree/folder.ts